let roles = {
    admin: 'Admin',
    aiAdmin: 'aia',
    dataEntry: 'Data Entry',
    dataEntryInterviewSurveys: 'deis',
    dataEntryJobHistory: 'dejh',
    developer: 'dev',
    featureEditor: 'Feature Editor',
    inHouseDataEntry: 'In-House Data Entry',
    internalRead: 'Internal Read',
    interviewers: 'iv',
    manageOrganization: 'Manage Organization',
    matching: 'Matching',
    read: 'Read',
    research: 'Research',
    salesAdmin: 'Sales Admin',
    subscribed: 'Subscribed',
}

roles.userRoles = [
    roles.admin,
    roles.aiAdmin,
    roles.dataEntry,
    roles.dataEntryInterviewSurveys,
    roles.dataEntryJobHistory,
    roles.featureEditor,
    roles.inHouseDataEntry,
    roles.internalRead,
    roles.interviewers,
    roles.manageOrganization,
    roles.matching,
    roles.research,
    roles.salesAdmin,
]

export const organizationRoles = [roles.read, roles.subscribed]

export const descriptions = {
    [roles.read]: {
        name: 'ManagementTrack Platform Access',
        description:
            'Allows access to all company and executive profiles and to premium research after six month embargo.',
    },
    [roles.subscribed]: {
        name: 'Paid Subscriber',
        description: 'Lifts six month embargo on premium research and removes download limits',
    },
    [roles.aiAdmin]: {
        name: 'AI Admin',
        description: 'Can update AI configuration',
    },
    [roles.dataEntryInterviewSurveys]: {
        name: 'Data Entry - Interview Surveys',
        description: 'Can edit interview survey data',
    },
    [roles.dataEntryJobHistory]: {
        name: 'Data Entry - Job History',
        description: 'Can edit executive job history',
    },
    [roles.interviewers]: {
        name: 'Interviewers',
        description: 'Can use interview redaction tool',
    },
}

export default roles
